
import React from 'react';
import { Leaf, TrendingDown, Award, DollarSign } from 'lucide-react';

const RSEBenefits = () => {
  const benefits = [
    {
      icon: Leaf,
      title: "Réduction empreinte carbone",
      description: "Diminution significative de votre impact environnemental",
      stat: "-40%",
      statLabel: "CO2 évité"
    },
    {
      icon: Award,
      title: "Valorisation image de marque",
      description: "Renforcement de votre réputation et attractivité",
      stat: "+25%",
      statLabel: "Attractivité"
    },
    {
      icon: TrendingDown,
      title: "Optimisation des coûts",
      description: "Réduction des coûts de gestion des déchets",
      stat: "-30%",
      statLabel: "Coûts"
    },
    {
      icon: DollarSign,
      title: "Conformité garantie",
      description: "Respect total de la réglementation en vigueur",
      stat: "100%",
      statLabel: "Conformité"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-heading font-bold mb-4 text-fabre-gray">
            Les Bénéfices pour Votre Entreprise
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Impact concret et mesurable sur votre performance RSE
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="group text-center"
            >
              <div className="bg-gradient-to-br from-fabre-lightgreen to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-fabre-green/10 hover:border-fabre-green/30">
                <div className="w-16 h-16 bg-gradient-to-br from-fabre-green to-fabre-teal rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                  <benefit.icon className="w-8 h-8 text-white" />
                </div>
                
                <div className="text-3xl font-bold text-fabre-green mb-2">
                  {benefit.stat}
                </div>
                <div className="text-sm text-gray-500 mb-4">
                  {benefit.statLabel}
                </div>
                
                <h3 className="text-lg font-bold text-fabre-gray mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RSEBenefits;
